import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { getGameData } from '../../proxy/riotApi';
import { ChampIcon } from './ChampIcon';
import { SummonerSpellIcon } from './SummonerSpellIcon';
import { RuneIcon } from './RuneIcon';
import { type GetActivityItem } from '../ActivityItem';
export const LeagueActivityFace = t0 => {
  const $ = _c(69);
  const {
    activity,
    size: t1,
    variant: t2
  } = t0;
  const size = t1 === undefined ? 96 : t1;
  const variant = t2 === undefined ? "normal" : t2;
  const {
    vendorGameId,
    vendorPlayerId
  } = activity;
  const matchId = vendorGameId || "";
  let t3;
  if ($[0] !== matchId) {
    t3 = {
      queryKey: ["game-data", {
        match: matchId
      }],
      queryFn: () => getGameData(matchId)
    };
    $[0] = matchId;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const gamesQuery = useQuery(t3);
  console.log({
    gamesQuery: gamesQuery.data,
    matchId
  });
  const isSlim = variant === "slim";
  if (gamesQuery.isLoading) {
    let t4;
    if ($[2] !== size) {
      t4 = <div style={{
        width: size,
        height: size
      }} className="bg-gray-500/50" />;
      $[2] = size;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== isSlim) {
      t5 = !isSlim && <div><div className="flex flex-row"><div className="w-8 h-8 bg-gray-500/50" /><div className="w-8 h-8 bg-gray-500/50" /><div className="w-8 h-8 bg-gray-500/50" /><div className="w-8 h-8 bg-gray-500/50" /><div className="w-8 h-8 bg-gray-500/50" /></div><div className="flex flex-row"><div className="w-8 h-8 bg-gray-500/50" /><div className="w-8 h-8 bg-gray-500/50" /><div className="w-8 h-8 bg-gray-500/50" /><div className="w-8 h-8 bg-gray-500/50" /><div className="w-8 h-8 bg-gray-500/50" /></div></div>;
      $[4] = isSlim;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    const t6 = `bg-gray-500/50 text-transparent ${isSlim ? "text-sm" : "text-lg"}`;
    let t7;
    if ($[6] !== t6) {
      t7 = <div className={t6}>0/0/0</div>;
      $[6] = t6;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    let t8;
    if ($[8] !== isSlim) {
      t8 = !isSlim && <div className="bg-gray-500/50 text-transparent">WIN</div>;
      $[8] = isSlim;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    let t9;
    if ($[10] !== t7 || $[11] !== t8) {
      t9 = <div className="flex flex-row items-center gap-2">{t7}{t8}</div>;
      $[10] = t7;
      $[11] = t8;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    let t10;
    if ($[13] !== isSlim || $[14] !== vendorPlayerId) {
      t10 = !isSlim && <><div className="bg-gray-500/50 text-transparent">{vendorPlayerId || "Summoner Name"}</div><div className="bg-gray-500/50 text-transparent">1/1/2024, 12:00:00 PM</div></>;
      $[13] = isSlim;
      $[14] = vendorPlayerId;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    let t11;
    if ($[16] !== t10 || $[17] !== t9) {
      t11 = <div className="flex flex-col items-start">{t9}{t10}</div>;
      $[16] = t10;
      $[17] = t9;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    let t12;
    if ($[19] !== t11 || $[20] !== t4 || $[21] !== t5) {
      t12 = <div className="flex flex-row gap-1 items-center animate-pulse">{t4}{t5}{t11}</div>;
      $[19] = t11;
      $[20] = t4;
      $[21] = t5;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    return t12;
  }
  if (!gamesQuery.data?.data || "httpStatus" in gamesQuery.data.data) {
    const t4 = `${isSlim ? "text-sm" : "text-lg"} text-gray-400`;
    let t5;
    if ($[23] !== t4) {
      t5 = <div className={t4}>Match unavailable (404)</div>;
      $[23] = t4;
      $[24] = t5;
    } else {
      t5 = $[24];
    }
    let t6;
    if ($[25] !== isSlim || $[26] !== matchId || $[27] !== vendorPlayerId) {
      t6 = !isSlim && <><div>{vendorPlayerId}</div><div className="text-gray-500">Match ID: {matchId}</div></>;
      $[25] = isSlim;
      $[26] = matchId;
      $[27] = vendorPlayerId;
      $[28] = t6;
    } else {
      t6 = $[28];
    }
    let t7;
    if ($[29] !== t5 || $[30] !== t6) {
      t7 = <div className="flex flex-row gap-1 items-center"><div className="flex flex-col items-start">{t5}{t6}</div></div>;
      $[29] = t5;
      $[30] = t6;
      $[31] = t7;
    } else {
      t7 = $[31];
    }
    return t7;
  }
  const game = gamesQuery.data.data;
  let t4;
  if ($[32] !== game.info?.participants || $[33] !== vendorPlayerId) {
    t4 = game.info?.participants?.find(e => `${e.riotIdGameName}#${e.riotIdTagline}` === vendorPlayerId);
    $[32] = game.info?.participants;
    $[33] = vendorPlayerId;
    $[34] = t4;
  } else {
    t4 = $[34];
  }
  const myPart = t4;
  let kda;
  let t5;
  let t6;
  let t7;
  if ($[35] !== game.info || $[36] !== isSlim || $[37] !== myPart || $[38] !== size) {
    const participants = game.info?.participants || [];
    const winnerId = game.info ? game.info.teams.filter(_temp)[0].teamId : null;
    const didWin = myPart?.teamId === winnerId;
    kda = ((myPart?.kills || 0) + (myPart?.assists || 0)) / Math.max(myPart?.deaths || 1, 1);
    t5 = "flex flex-row gap-1 items-center";
    const t8 = didWin ? `border-l-${isSlim ? "2" : "4"} border-l-green-400` : `border-l-${isSlim ? "2" : "4"} border-l-red-400`;
    const t9 = myPart?.championId;
    if ($[43] !== size || $[44] !== t8 || $[45] !== t9) {
      t6 = <ChampIcon className={t8} championId={t9} size={size} />;
      $[43] = size;
      $[44] = t8;
      $[45] = t9;
      $[46] = t6;
    } else {
      t6 = $[46];
    }
    t7 = !isSlim && <><div className="flex flex-col gap-1">{myPart && <><SummonerSpellIcon spellId={myPart.summoner1Id} size={40} /><SummonerSpellIcon spellId={myPart.summoner2Id} size={40} /></>}</div><div className="flex flex-col gap-1">{myPart?.perks?.styles?.[0]?.selections?.[0] && <RuneIcon runeId={myPart.perks.styles[0].selections[0].perk} size={40} showTitle={true} />}{myPart?.perks?.styles?.[1] && <RuneIcon runeId={myPart.perks.styles[1].style} size={40} showTitle={true} />}</div><div><div className="flex flex-row">{participants.filter(_temp2).map(e_2 => <ChampIcon key={e_2.puuid} championId={e_2?.championId} size={size / 2} />)}</div><div className="flex flex-row">{participants.filter(_temp3).map(e_4 => <ChampIcon key={e_4.puuid} championId={e_4?.championId} size={size / 2} />)}</div></div></>;
    $[35] = game.info;
    $[36] = isSlim;
    $[37] = myPart;
    $[38] = size;
    $[39] = kda;
    $[40] = t5;
    $[41] = t6;
    $[42] = t7;
  } else {
    kda = $[39];
    t5 = $[40];
    t6 = $[41];
    t7 = $[42];
  }
  const t8 = `${isSlim ? "text-sm" : "text-lg"} text-orange-500`;
  const t9 = myPart?.kills;
  const t10 = myPart?.deaths;
  const t11 = myPart?.assists;
  let t12;
  if ($[47] !== kda) {
    t12 = kda.toFixed(1);
    $[47] = kda;
    $[48] = t12;
  } else {
    t12 = $[48];
  }
  let t13;
  if ($[49] !== t12) {
    t13 = <span className="text-gray-500">({t12})</span>;
    $[49] = t12;
    $[50] = t13;
  } else {
    t13 = $[50];
  }
  let t14;
  if ($[51] !== t10 || $[52] !== t11 || $[53] !== t13 || $[54] !== t8 || $[55] !== t9) {
    t14 = <div className="flex flex-row items-center gap-2"><div className={t8}>{t9}/{t10}/{t11}{" "}{t13}</div></div>;
    $[51] = t10;
    $[52] = t11;
    $[53] = t13;
    $[54] = t8;
    $[55] = t9;
    $[56] = t14;
  } else {
    t14 = $[56];
  }
  let t15;
  if ($[57] !== game.info?.gameDuration || $[58] !== isSlim || $[59] !== myPart) {
    t15 = !isSlim && myPart && <div className="flex flex-col text-sm text-gray-300 gap-1"><div>{(myPart.totalMinionsKilled || 0) + (myPart.neutralMinionsKilled || 0)} CS ({(((myPart.totalMinionsKilled || 0) + (myPart.neutralMinionsKilled || 0)) / Math.max((game.info?.gameDuration || 1) / 60, 1)).toFixed(1)})</div></div>;
    $[57] = game.info?.gameDuration;
    $[58] = isSlim;
    $[59] = myPart;
    $[60] = t15;
  } else {
    t15 = $[60];
  }
  let t16;
  if ($[61] !== t14 || $[62] !== t15) {
    t16 = <div className="flex flex-col" id="personal-stats">{t14}{t15}</div>;
    $[61] = t14;
    $[62] = t15;
    $[63] = t16;
  } else {
    t16 = $[63];
  }
  let t17;
  if ($[64] !== t16 || $[65] !== t5 || $[66] !== t6 || $[67] !== t7) {
    t17 = <div className={t5}>{t6}{t7}{t16}</div>;
    $[64] = t16;
    $[65] = t5;
    $[66] = t6;
    $[67] = t7;
    $[68] = t17;
  } else {
    t17 = $[68];
  }
  return t17;
};
function _temp(e_0) {
  return e_0.win;
}
function _temp2(e_1) {
  return e_1.teamId == 100;
}
function _temp3(e_3) {
  return e_3.teamId == 200;
}